<ion-fab *ngIf="show" class="c-platform" slot="fixed" vertical="bottom" horizontal="end">
  <ion-fab-button class="c-platform__button" (click)="openPlatformOptions()">
    <ion-icon name="settings-outline"></ion-icon>
  </ion-fab-button>
</ion-fab>